import Node from '@/tiptap/tiptap/Utils/Node';
import ResourceMentionComponent from '@/components/editor/ResourceMentionComponent.vue';

export default class ResourceMention extends Node {
  get name() {
    return 'resourceMention';
  }

  get schema() {
    return {
      attrs: {
        kind: {},
        id: {},
        title: {},
      },
      group: 'inline',
      inline: true,
      selectable: false,
      atom: true,
      toDOM: (node) => [
        'a',
        {
          class: 'resource-mention-component',
          'data-resource-kind': node.attrs.kind,
          'data-resource-id': node.attrs.id,
          'data-resource-title': node.attrs.title,
        },
        node.attrs.title,
      ],
      parseDOM: [
        {
          tag: 'a[data-resource-id]',
          getAttrs: (dom) => ({
            kind: dom.getAttribute('data-resource-kind'),
            id: parseInt(dom.getAttribute('data-resource-id'), 10),
            title: dom.getAttribute('data-resource-title'),
          }),
        },
      ],
    };
  }

  get view() {
    return ResourceMentionComponent;
  }
}
